// TODO: Deprecated this Button component, please use the new button (button/v2) component from design system
import React, { ReactNode } from "react";
import { cn } from "../../../lib/utils";
import { CheckCheck } from "lucide-react";
import styles from './ReviewerButton.module.css'

type ReviewerButtonVariant = "reviewer" | "approved";

interface ReviewerButtonProps {
  text: string;
  onClick: () => void;
  disabled?: boolean;
  variant?: ReviewerButtonVariant;
  buttonClassName?: string;
  textClassName?: string;
  iconClassName?: string;
  icon?: ReactNode;
}

const ReviewerButton: React.FC<ReviewerButtonProps> = ({
  text,
  onClick,
  disabled,
  variant = "reviewer",
  buttonClassName,
  textClassName,
  iconClassName,
  icon,
}) => {
  const variantButtonClassName = cn(
    styles.button,
    disabled && styles.disabled,
    !buttonClassName && styles[variant], // only apply CSS variant if no custom override
    buttonClassName
  );
  
  const variantTextClassName = cn(
    styles.text,
    disabled && styles.disabled,
    textClassName
  );
  
  const variantIconClassName = cn(
    styles.icon,
    disabled && styles.disabled,
    iconClassName
  );

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={cn('button', variantButtonClassName, buttonClassName)}
    >
      <span className={cn('icon', variantIconClassName, iconClassName)}>
        {icon ? icon : <CheckCheck className={styles.icon} />}
      </span>
      <span className={cn('text', variantTextClassName, textClassName)}>{text}</span>
    </button>
  );
};

export default ReviewerButton;
